import { Bell } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import type { INotificationBellProps } from '@/@types/notification';

export function NotificationBell({ unreadCount, onClick }: INotificationBellProps) {
  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={onClick}
      className="relative"
      title="Notifications"
      aria-label="Notifications"
      data-testid="notification-bell"
    >
      <Bell className="w-5 h-5" />
      {unreadCount > 0 && (
        <span
          className={cn(
            'absolute -top-0.5 -right-0.5 flex items-center justify-center',
            'min-w-[18px] h-[18px] px-1 rounded-full',
            'bg-destructive text-destructive-foreground text-[10px] font-bold'
          )}
        >
          {unreadCount > 99 ? '99+' : unreadCount}
        </span>
      )}
    </Button>
  );
}
